import { render, staticRenderFns } from "./TableItems.vue?vue&type=template&id=7242a6b5"
import script from "./TableItems.vue?vue&type=script&lang=js"
export * from "./TableItems.vue?vue&type=script&lang=js"
import style0 from "./TableItems.vue?vue&type=style&index=0&id=7242a6b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports